export default (axios) => ({
  getActualVersion() {
    return axios.get('v1/last_version')
  },
  updateVersionCode(payload) {
    return axios.post('v1/last_version', payload)
  }
})
